module.exports = require('./helpers/bundle-url').getBundleURL('enTGv') + "logo.c51670a8.svg";